(function($) {
	
	'use strict'
	
	var init = function() {
		initSwiper()
	}

	var initSwiper = function() {
		var swiper = new Swiper('.event', {
            slidesPerView: 1,
			spaceBetween: 0,
			loop: true,
			// centeredSlides: true,
			centeredSlidesBounds: true,
			breakpoints: {
				768: {
					slidesPerView: 2,
                },
                992: {
					slidesPerView: 3,
					resistanceRatio: 0,
                },
            },

			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},

			pagination: {
				el: '.swiper-pagination',
				type: 'bullets',
				clickable: true,
			},
        })
	}

	$(document).ready(function() {
		init()
	})

})(jQuery)
